import { trackFunnelEvent } from "./funnelTracking";

const RECEIPT_KEY = "ajp_student_enquiry_receipt_v1";
const TRACKED_KEY = "ajp_student_conversion_refs_v1";
const RECEIPT_MAX_AGE = 24 * 60 * 60 * 1000;

const clean = (value, length = 160) => String(value == null ? "" : value).trim().slice(0, length);

export const trackStudentEvent = (eventName, details = {}) => {
  if (typeof window === "undefined") return;
  const payload = {
    quote_id: details.quoteId || details.quote_id,
    vehicle_code: clean(details.vehicleCode || details.vehicle_code, 80),
    cta_type: clean(details.ctaType || details.cta_type, 80),
    fare_gbp: details.fareGbp ?? details.fare_gbp,
    step_name: clean(details.stepName || details.step_name, 80),
    step_number: details.stepNumber || details.step_number,
    status: clean(details.status, 40),
    event_category: "student_arrival_guide",
    conversion_role: details.conversionRole || "engagement",
    section_key: clean(details.sectionKey, 60),
    enquiry_type: clean(details.enquiryType, 60),
    enquiry_reference: clean(details.refCode || details.enquiryReference, 60),
    airport: clean(details.airport, 12),
    landing_page: clean(details.landingPage, 220),
    option_type: clean(details.optionType, 40),
    passengers: details.passengers,
    bags: details.bags,
    has_results: details.hasResults,
    failure_reason: clean(details.failureReason, 220)
  };
  trackFunnelEvent(eventName, { brand: "planner", ...payload });
};

export const completeStudentEnquiry = (navigate, details = {}) => {
  const confirmation = {
    refCode: clean(details.refCode || "Submitted", 60),
    enquiryType: clean(details.enquiryType || "Student support", 80),
    sectionKey: clean(details.sectionKey, 60),
    returnPath: clean(details.returnPath || "/international-students/uk-arrival-guide", 220),
    summary: clean(details.summary, 220),
    submittedAt: new Date().toISOString()
  };
  try { window.sessionStorage.setItem(RECEIPT_KEY, JSON.stringify(confirmation)); } catch { /* receipt still travels in navigation state */ }

  let alreadyTracked = false;
  try {
    const tracked = JSON.parse(window.sessionStorage.getItem(TRACKED_KEY) || "[]");
    alreadyTracked = Array.isArray(tracked) && tracked.includes(confirmation.refCode);
    if (!alreadyTracked) window.sessionStorage.setItem(TRACKED_KEY, JSON.stringify([...(Array.isArray(tracked) ? tracked : []), confirmation.refCode].slice(-50)));
  } catch { /* conversion tracking is best effort */ }

  if (!alreadyTracked) {
    trackStudentEvent("student_enquiry_submitted", { ...details, conversionRole: "primary" });
    const conversion = { transaction_id: confirmation.refCode, enquiry_type: clean(details.enquiryType, 60), section_key: confirmation.sectionKey };
    if (typeof window.gtag === "function") {
      window.gtag("event", "generate_lead", conversion);
      const sendTo = process.env.REACT_APP_GOOGLE_ADS_STUDENT_ENQUIRY_SEND_TO || process.env.REACT_APP_GOOGLE_ADS_ENQUIRY_SEND_TO;
      if (sendTo) window.gtag("event", "conversion", { send_to: sendTo, transaction_id: confirmation.refCode });
    }
  }
  navigate("/international-students/enquiry-received", { replace: true, state: { confirmation } });
};

export const readStudentEnquiryReceipt = () => {
  if (typeof window === "undefined") return null;
  try {
    const receipt = JSON.parse(window.sessionStorage.getItem(RECEIPT_KEY) || "null");
    const submitted = new Date(receipt?.submittedAt).getTime();
    if (!submitted || Date.now() - submitted > RECEIPT_MAX_AGE) return null;
    return receipt;
  } catch { return null; }
};
